import { gql } from 'apollo-angular'

export const CREATE_USER = gql`
  mutation CreateUser(
    $email: String!
    $password: String!
    $name: String!
    $firstName: String!
    $lastName: String!
    $recaptchaToken: String
    $articleToPurchase: Int
  ) {
    createUser(
      data: {
        email: $email
        password: $password
        name: $name
        first_name: $firstName
        last_name: $lastName
        recaptchaToken: $recaptchaToken
        articleToPurchase: $articleToPurchase
      }
    ) {
      id
      organization {
        name
        id
      }
    }
  }
`
